// Web driver: localStorage. The web build is a development preview only —
// real devices use the sqlite driver. Same DocStore contract.

import type { DocStore, TableName } from './types';

const PREFIX = 'opiekun:';

function readTable(table: TableName): Record<string, unknown> {
  try {
    const raw = globalThis.localStorage?.getItem(PREFIX + table);
    return raw ? (JSON.parse(raw) as Record<string, unknown>) : {};
  } catch {
    return {};
  }
}

function writeTable(table: TableName, data: Record<string, unknown>) {
  globalThis.localStorage?.setItem(PREFIX + table, JSON.stringify(data));
}

export function createWebStore(): DocStore {
  return {
    async init() {
      // localStorage needs no setup
    },
    async list<T>(table: TableName): Promise<T[]> {
      return Object.values(readTable(table)) as T[];
    },
    async upsert(table: TableName, id: string, doc: unknown) {
      const data = readTable(table);
      data[id] = doc;
      writeTable(table, data);
    },
    async remove(table: TableName, id: string) {
      const data = readTable(table);
      delete data[id];
      writeTable(table, data);
    },
    async getKv(key: string) {
      return globalThis.localStorage?.getItem(`${PREFIX}kv:${key}`) ?? null;
    },
    async setKv(key: string, value: string) {
      globalThis.localStorage?.setItem(`${PREFIX}kv:${key}`, value);
    },
  };
}
